module.exports = __webpack_public_path__ + "img/index10.627af95d.png";